import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

import VueLazyload from 'vue-lazyload'

import './styles/index.scss'
import { message } from 'ant-design-vue'
import './styles/quill.scss'
import _ from 'lodash'
import dayjs from 'dayjs'
import filters from "@/assets/filters/index.js"

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview);

/*配置图片懒加载*/
//const loadimage = require('./assets/loading.gif')
const errorimage = require('./assets/img/error.jpg')

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: errorimage,
  loading: errorimage,
  attempt: 1
})
/*配置图片懒加载*/


/*配置全局过滤器*/
Object.keys(filters).forEach(v => {
  // 注册
  Vue.filter(v, filters[v])
});
/*配置全局过滤器*/


// var option = {
//   maxSpreadZoom: 1, // 控制预览图最大的倍数，默认是2倍，我这里改成了原图
//   fullscreenEl: false, //控制是否显示右上角全屏按钮
//   closeEl: false, //控制是否显示右上角关闭按钮
//   tapToClose: true, //点击滑动区域应关闭图库
//   shareEl: false, //控制是否显示分享按钮
//   zoomEl: false, //控制是否显示放大缩小按钮
//   counterEl: false, //控制是否显示左上角图片数量按钮
//   arrowEl: true, //控制如图的左右箭头（pc浏览器模拟手机时）
//   tapToToggleControls: true, //点击应切换控件的可见性
//   clickToCloseNonZoomable: true //点击图片应关闭图库，仅当图像小于视口的大小时
// }
// Vue.use(preview, option)

import vueSwiper from 'vue-awesome-swiper'
Vue.use(vueSwiper)

Vue.config.productionTip = false
Vue.use(Antd)
import 'animate.css'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.prototype.$message = message
Vue.prototype.$_ = _
Vue.prototype.$dayjs = dayjs

// main.js 文件
import global from './utils/global.js'
Vue.prototype.global = global
